// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2aeA8","title":"Header_title__2bMU6","side":"Header_side__1B_qf"};